import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAcerComponent } from './simple-icons-acer.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAcerComponent ],
    exports:      [ SimpleIconsAcerComponent ],
    bootstrap:    []
})
export class SimpleIconsAcerModule {}
